//
// # Primitives
//
// The `Shape` and `Primitive` union types
//
// Collect up everything
import { ArcEntity } from "./arc";
import { EllipseEntity } from "./ellipse";
import { PathEntity } from "./path";
import { PolygonEntity } from "./polygon";
import { RectEntity } from "./rect";
import { TextEntity } from "./text";

// And export the union types
export type Shape =
  | RectEntity
  | ArcEntity
  | EllipseEntity
  | PathEntity
  | PolygonEntity;

export type Primitive = Shape | TextEntity;
